export const DEFAULT_KARMA_RULES = {
  minimum: -20,
  maximum: 100,
  honorableThreshold: 20,
  saintThreshold: 50,
  veryTrustedThreshold: 70,
  exemplaryThreshold: 100,
  partnerRestrictionThreshold: -1,
  dailyXpPenaltyThreshold: -10,
  tribunalRevocationThreshold: -5,
  temporarySuspensionThreshold: -20,
  temporarySuspensionMonths: 1,
};

export function karmaRulesFromSettings(settings = {}) {
  const map = {
    minimum: 'KarmaMinimum', maximum: 'KarmaMaximum', honorableThreshold: 'KarmaHonorableThreshold',
    saintThreshold: 'KarmaSaintThreshold', veryTrustedThreshold: 'KarmaVeryTrustedThreshold',
    exemplaryThreshold: 'KarmaExemplaryThreshold', partnerRestrictionThreshold: 'KarmaPartnerRestrictionThreshold',
    dailyXpPenaltyThreshold: 'KarmaDailyXpPenaltyThreshold', tribunalRevocationThreshold: 'KarmaTribunalRevocationThreshold',
    temporarySuspensionThreshold: 'KarmaTemporarySuspensionThreshold', temporarySuspensionMonths: 'KarmaTemporarySuspensionMonths',
  };
  return Object.fromEntries(Object.entries(map).map(([field, key]) => [field, Number(settings[key] ?? DEFAULT_KARMA_RULES[field])]));
}

export const formatKarma = (value) => Number(value) > 0 ? `+${value}` : `${value}`;
